import { FC } from 'react';
import Wizard from './EvaluationWizard';

/** The wizard reads its seed and way back from useLocation, so it takes no props. */
export type EvaluationWizardProps = Record<string, never>;

export const EvaluationWizard: FC<EvaluationWizardProps> = Wizard;
